import {Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {TokenStorageService} from '../../../../services/token.storage.service';
import {DocumentService} from '../../../../services/document-service';
import {Currency, Document, DocumentSection} from '../../../../model/continent';
import {Location, NgForOf, NgIf} from '@angular/common';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {PdfViewerComponent} from '../../admin/elements/pdf-viewer/pdf-viewer.component';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {IconComponent} from '../../../elements/icon/icon.component';
import {Icons} from '../../../../model/icon';
import {LoadingComponent} from '../../../elements/loading/loading.component';
import {Notification, NotificationType} from '../../../../model/notification';
import {NotificationService} from '../../../../services/notification-service';
import {animate, query, stagger, style, transition, trigger} from '@angular/animations';
import {NotificationStyleService} from '../../../../services/notification-style-service';
import {scrollUp} from '../../../../functions/scroll-up';

@Component({
  selector: 'app-voucher-page',
  imports: [
    PdfViewerComponent,
    ReactiveFormsModule,
    FormsModule,
    RouterLink,
    IconComponent,
    LoadingComponent,
    NgIf,
    NgForOf
  ],
  templateUrl: './voucher-page.component.html',
  standalone: true,
  styleUrl: './voucher-page.component.scss',
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ height: 0, opacity: 0, overflow: 'hidden' }),
        animate('300ms ease-out',
          style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, overflow: 'hidden' }),
        animate('300ms ease-in',
          style({ height: 0, opacity: 0 }))
      ])
    ]),
    trigger('staggerSlide', [
      transition(':enter', [
        query('.field-array-item:not(.deleting)', [
          style({ opacity: 0, transform: 'translateY(-10px)' }),
          stagger('100ms', [
            animate('300ms ease-out',
              style({ opacity: 1, transform: 'translateY(0)' }))
          ])
        ], { optional: true })
      ]),
      transition(':leave', [
        query('.field-array-item.deleting', [
          stagger('-100ms', [
            animate('300ms ease-in',
              style({
                opacity: 0,
                transform: 'scale(0.8) translateY(20px)',
                height: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0
              }))
          ])
        ], { optional: true })
      ])
    ]),
    trigger('itemAdd', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.8) translateY(-20px)' }),
        animate('400ms cubic-bezier(0.34, 1.56, 0.64, 1)',
          style({ opacity: 1, transform: 'scale(1) translateY(0)' }))
      ])
    ]),
    trigger('itemRemove', [
      transition(':leave', [
        style({ opacity: 1, transform: 'scale(1)', height: '*' }),
        animate('300ms ease-in',
          style({
            opacity: 0,
            transform: 'scale(0.8) translateY(20px)',
            height: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0
          }))
      ])
    ])
  ]
})
export class VoucherPageComponent implements OnInit, OnDestroy {
  constructor(
    protected tokenStorageService: TokenStorageService,
    private documentService: DocumentService,
    public location: Location,
    protected route: ActivatedRoute,
    private fb: FormBuilder,
    protected notificationService: NotificationService,
    private router: Router,
    protected notificationStyle: NotificationStyleService,
  ) {
    this.myForm = this.fb.group({});
  }

  private tokenCheckInterval?: any;
  currentUser: string | null = null;
  userRole: string = '';
  currencyType: string[] = [];
  currencies: Currency[] = [
    { code: 'EUR', symbol: '€' },
    { code: 'USD', symbol: '$' },
    { code: 'RUB', symbol: '₽' },
    { code: 'AED', symbol: 'AED' },
    { code: 'GBP', symbol: '£' },
    { code: 'USDT', symbol: '₮' },
  ];

  document: Document = new Document({
    type: 'VOUCHER',
    hotels: [],
    departures: [],
    transits: [],
    arrivals: [],
    transfers: [],
    active: true,
    version: 0
  });
  sectionArrays: DocumentSection[] = [];

  primalDocument: Document = new Document(this.document);
  primalId: number | undefined = undefined;
  primalType: string = 'VOUCHER';
  primalDate: string | undefined = undefined;

  title: string = '';
  pdfUrl: string = 'app/assets/test.pdf';
  myForm: FormGroup;
  documentType: string = '';
  documentTypes: string[] = ['VOUCHER', 'OFFER'];

  openArrays: boolean = false;

  isTab: boolean = false;
  isMobile: boolean = false;

  activeMobileSection: 'redactor' | 'pdf' = 'redactor';

  editing: boolean = false;

  loading: boolean = false;

  showDeleteModal: boolean = false;
  showEditModeModal: boolean = false;
  documentToDelete: number | undefined;

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isTab = window.innerWidth <= 769;
    this.isMobile = window.innerWidth <= 521;
    if (this.isTab || this.isMobile) {
      this.activeMobileSection = 'redactor';
    }
  }

  ngOnInit(): void {
    this.loading = true;
    this.initializeComponent();
    this.startTokenMonitoring();
    this.checkScreenSize();
    this.notificationStyle.setDocumentStyle(1);
    if (this.isTab || this.isMobile) {
      this.activeMobileSection = 'pdf';
    }
  }

  ngOnDestroy(): void {
    if (this.tokenCheckInterval) {
      clearInterval(this.tokenCheckInterval);
    }
    this.notificationStyle.setDocumentStyle(0);
  }

  showSections(type: 'redactor' | 'pdf') {
    if (this.isTab || this.isMobile) {
      return this.activeMobileSection === type;
    } else {
      return true;
    }
  }

  switchMobileSection(section: 'redactor' | 'pdf'): void {
    this.activeMobileSection = section;
    if (section === 'redactor') {
      setTimeout(() => {
        this.initializeTextareasHeight();
      }, 300);
    }
  }

  openArray(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.openArrays = !this.openArrays;
    if (this.openArrays) {
      setTimeout(() => {
        this.initializeTextareasHeight();
      }, 50);
    }
  }

  rotateSection(type: 'up' | 'down', idx: number) {
    if (!this.editing || this.loading) return;
    if (idx < 0 || idx >= this.sectionArrays.length) return;
    if (type === 'up' && idx === 0) return;
    if (type === 'down' && idx === this.sectionArrays.length - 1) return;
    let targetIdx: number;
    if (type === 'up') {
      targetIdx = idx - 1;
    } else {
      targetIdx = idx + 1;
    }
    [this.sectionArrays[idx], this.sectionArrays[targetIdx]] =
      [this.sectionArrays[targetIdx], this.sectionArrays[idx]];
    this.updateOrderNumbers();
    setTimeout(() => this.initializeTextareasHeight(), 50);
  }

  private updateOrderNumbers(): void {
    this.sectionArrays.forEach((section, index) => {
      section.orderNumber = index;
    });
  }

  isFirstSection(idx: number): boolean {
    return idx === 0;
  }

  isLastSection(idx: number): boolean {
    return idx === this.sectionArrays.length - 1;
  }

  checkLength(type: 'Hotels' | 'Departures' | 'Transits' | 'Arrivals' | 'Transfers'): boolean {
    switch (type) {
      case 'Hotels': return this.sectionArrays.some(item => item.type === 'Hotel');
      case 'Departures': return this.sectionArrays.some(item => item.type === 'Departure');
      case 'Transits': return this.sectionArrays.some(item => item.type === 'Transit');
      case 'Arrivals': return this.sectionArrays.some(item => item.type === 'Arrival');
      case 'Transfers': return this.sectionArrays.some(item => item.type === 'Transfer');
      default: return false;
    }
  }

  getCountByType(type: 'Hotels' | 'Departures' | 'Transits' | 'Arrivals' | 'Transfers'): number {
    return this.sectionArrays.filter(item => {
      switch (type) {
        case 'Hotels': return item.type === 'Hotel';
        case 'Departures': return item.type === 'Departure';
        case 'Transits': return item.type === 'Transit';
        case 'Arrivals': return item.type === 'Arrival';
        case 'Transfers': return item.type === 'Transfer';
        default: return false;
      }
    }).length;
  }

  private initializeComponent(): void {
    this.currentUser = this.tokenStorageService.getUsername();
    this.userRole = this.tokenStorageService.getPrimaryRole();
    if (!this.tokenStorageService.canAccessVouchers()) {
      return;
    }
    this.createForm();
    this.loadVoucher();
  }

  createForm() {
    this.myForm.addControl('id', this.fb.control({value: '', disabled: true}));
    this.myForm.addControl('type', this.fb.control({value: '', disabled: false}, Validators.required));
    this.myForm.addControl('documentDate', this.fb.control({value: '', disabled: false}));
    this.myForm.addControl('hotels', this.fb.control({value: '', disabled: false}));
    this.myForm.addControl('departures', this.fb.control({value: '', disabled: false}));
    this.myForm.addControl('transits', this.fb.control({value: '', disabled: false}));
    this.myForm.addControl('arrivals', this.fb.control({value: '', disabled: false}));
    this.myForm.addControl('transfers', this.fb.control({value: '', disabled: false}));
  }

  private loadVoucher(): void {
    const path = this.route.snapshot.paramMap.get('id') ?? 'add';
    if (path !== 'add') {
      const id = Number(path);
      this.documentService.getDocument(id).subscribe((data) => {
        this.document = new Document(data);
        this.primalDocument = new Document(JSON.parse(JSON.stringify(data)));
        this.primalId = this.primalDocument.id;
        this.primalType = this.primalDocument.type;
        this.primalDate = this.document.documentDate;
        if (this.isMobile) {
          this.title = this.document.id?.toString() ?? 'New';
        } else {
          this.title = `${this.document.type} — ${this.document.id}`;
        }
        this.setArrays();
        this.setType(this.document.type);
        this.documentType = this.document.type;
        this.myForm.patchValue(this.document);
        this.initializeCurrencyTypes();
        this.documentService.getDocumentStream(id, 'document-voucher-template.jrxml').subscribe((temp: any) => {
          this.pdfUrl = URL.createObjectURL(temp);
          this.loading = false;
          setTimeout(() => {
            this.initializeTextareasHeight();
          }, 200);
        });
      });
    } else {
      this.loading = false;
      if (this.isMobile) {
        this.title = 'New';
        this.activeMobileSection = 'redactor';
      } else {
        this.title = 'New Item';
      }
      this.editing = true;
      this.currencyType = [];
    }
  }

  private setArrays() {
    const allSections: DocumentSection[] = [
      ...this.document.hotels.map(h => ({
        ...h,
        type: 'Hotel' as const
      })),
      ...this.document.departures.map(d => ({
        ...d,
        type: 'Departure' as const
      })),
      ...this.document.transits.map(t => ({
        ...t,
        type: 'Transit' as const
      })),
      ...this.document.arrivals.map(a => ({
        ...a,
        type: 'Arrival' as const
      })),
      ...this.document.transfers.map(t => ({
        ...t,
        type: 'Transfer' as const
      }))
    ];
    const orderNumberMap = new Map<number, DocumentSection[]>();
    allSections.forEach((section) => {
      const orderNum = section.orderNumber;
      if (orderNum === null || orderNum === undefined ||
        typeof orderNum !== 'number' || orderNum < 0) {
        return;
      }
      if (!orderNumberMap.has(orderNum)) {
        orderNumberMap.set(orderNum, []);
      }
      orderNumberMap.get(orderNum)!.push(section);
    });
    const duplicateOrders: number[] = [];
    orderNumberMap.forEach((sections, orderNum) => {
      if (sections.length > 1) {
        duplicateOrders.push(orderNum);
      }
    });
    if (duplicateOrders.length > 0) {
      const usedOrderNumbers = new Set<number>();
      allSections.forEach(section => {
        const orderNum = section.orderNumber;
        if (orderNum !== null && orderNum !== undefined &&
          typeof orderNum === 'number' && orderNum >= 0) {
          usedOrderNumbers.add(orderNum);
        }
      });
      const maxOrderNumber = usedOrderNumbers.size > 0 ? Math.max(...usedOrderNumbers) : -1;
      let nextAvailableOrderNumber = maxOrderNumber + 1;
      duplicateOrders.forEach(orderNum => {
        const duplicateSections = orderNumberMap.get(orderNum)!;
        for (let i = 1; i < duplicateSections.length; i++) {
          const section = duplicateSections[i];
          section.orderNumber = nextAvailableOrderNumber;
          usedOrderNumbers.add(nextAvailableOrderNumber);
          nextAvailableOrderNumber++;
        }
      });
    }
    allSections.sort((a, b) => {
      const orderA = a.orderNumber ?? Infinity;
      const orderB = b.orderNumber ?? Infinity;
      if (orderA === orderB) {
        return (a.type || '').localeCompare(b.type || '');
      }
      return orderA - orderB;
    });
    let nextOrderNumber = 0;
    allSections.forEach((section) => {
      const currentOrderNum = section.orderNumber;
      if (currentOrderNum === null || currentOrderNum === undefined ||
        typeof currentOrderNum !== 'number' || currentOrderNum < 0) {
        section.orderNumber = nextOrderNumber;
      }
      else if (currentOrderNum !== nextOrderNumber) {
        let isConflict = false;
        for (let i = 0; i < allSections.indexOf(section); i++) {
          if (allSections[i].orderNumber === currentOrderNum) {
            isConflict = true;
            break;
          }
        }
        if (isConflict) {
          section.orderNumber = nextOrderNumber;
        } else {
          section.orderNumber = currentOrderNum;
          nextOrderNumber = Math.max(nextOrderNumber, currentOrderNum + 1);
          return;
        }
      }
      nextOrderNumber++;
    });
    this.sectionArrays = allSections;
  }

  private initializeCurrencyTypes(): void {
    const allCurrencies: string[] = [];
    this.document.hotels.forEach(hotel => {
      allCurrencies.push(hotel.currency || '');
    });
    this.document.departures.forEach(departure => {
      allCurrencies.push(departure.currency || '');
    });
    this.document.transits.forEach(transit => {
      allCurrencies.push(transit.currency || '');
    });
    this.document.arrivals.forEach(arrival => {
      allCurrencies.push(arrival.currency || '');
    });
    this.document.transfers.forEach(transfer => {
      allCurrencies.push(transfer.currency || '');
    });
    this.currencyType = allCurrencies;
  }

  private startTokenMonitoring(): void {
    this.tokenCheckInterval = setInterval(() => {
      if (!this.tokenStorageService.isTokenValid()) {
        this.tokenStorageService.logout();
      }
    }, 30000);
  }

  onSubmit() {
    if (this.loading) {
      return;
    }
    if (this.myForm.valid) {
      this.loading = true;
      const documentToSave = this.prepareDocumentForSave();
      this.documentService.saveDocument(documentToSave).subscribe({
        next: (data) => {
          let notification: string;
          const path = this.route.snapshot.paramMap.get('id') ?? 'add';
          if (path !== 'add') {
            notification = `document ${documentToSave.type} - ${documentToSave.id}`;
          } else {
            notification = `new document ${documentToSave.type}`;
          }
          this.notificationService.implementNotification(new Notification({
            title: `Success`,
            text: `The ${notification} has been saved`,
            style: NotificationType.success
          }), 5000);
          if (path !== 'add') {
            this.document = data;
            this.setArrays();
            this.loadVoucher();
            this.loading = false;
            this.editing = false;
          } else {
            this.router.navigate([`/documents/${data.id}`]).then(() => {
              scrollUp();
              this.resetComponentState();
              this.loadVoucher();
            });
          }
        },
        error: () => {
          this.notificationService.implementNotification(new Notification({
            title: 'Error',
            text: `Failed to save document`,
            style: NotificationType.error
          }), 5000);
          this.loading = false;
        }
      });
    }
  }

  edit() {
    if (this.loading) {
      return
    }
    this.editing = true;
  }

  downloadFile() {
    const name = (this.document.type +
      '-' + (this.document.hotels[0]?.hotelName ?? 'hotel') +
      '-' + (this.document.hotels[0]?.guestNames ?? '') +
      '-' +  this.document.documentDate + '.pdf')
      .toLowerCase()
      .replaceAll(" ", "-")
      .replaceAll(",", "-")
      .replaceAll("\n", "")
      .replaceAll("_", "-")
      .replaceAll("_", "-")
      .replaceAll("--", "-");
    const a = document.createElement('a');
    a.href = this.pdfUrl;
    a.download = name;
    a.click();
    URL.revokeObjectURL(this.pdfUrl);
  }

  cancel() {
    if (this.loading) {
      return;
    }
    if (!this.isDocumentsEqual(this.document, this.primalDocument) ||
      this.primalDate !== this.document.documentDate ||
      this.primalType !== this.document.type ||
      this.primalId !== this.document.id) {
      this.document = new Document({ ...this.primalDocument });
      this.document.documentDate = this.primalDate;
      this.document.type = this.primalType;
      this.document.id = this.primalId;
      this.setArrays();
    }
    this.editing = false;
  }

  private isDocumentsEqual(doc1: Document, doc2: Document): boolean {
    if (doc1 === doc2) return true;
    if (!doc1 || !doc2) return false;
    if (doc1.id !== doc2.id ||
      doc1.documentDate !== doc2.documentDate ||
      doc1.type !== doc2.type ||
      doc1.active !== doc2.active ||
      doc1.column !== doc2.column) {
      return false;
    }
    if (!this.areDocumentSectionsEqual(doc1.hotels, doc2.hotels) ||
      !this.areDocumentSectionsEqual(doc1.departures, doc2.departures) ||
      !this.areDocumentSectionsEqual(doc1.transits, doc2.transits) ||
      !this.areDocumentSectionsEqual(doc1.arrivals, doc2.arrivals) ||
      !this.areDocumentSectionsEqual(doc1.transfers, doc2.transfers)) {
      return false;
    }
    return true;
  }

  private areDocumentSectionsEqual(sections1: DocumentSection[], sections2: DocumentSection[]): boolean {
    if (sections1.length !== sections2.length) return false;
    for (let i = 0; i < sections1.length; i++) {
      if (!this.isDocumentSectionEqual(sections1[i], sections2[i])) {
        return false;
      }
    }
    return true;
  }

  private isDocumentSectionEqual(section1: DocumentSection, section2: DocumentSection): boolean {
    if (section1 === section2) return true;
    if (!section1 || !section2) return false;
    return JSON.stringify(section1) === JSON.stringify(section2);
  }

  setType(value: any) {
    this.myForm.patchValue({
      type: value
    });
    const path = this.route.snapshot.paramMap.get('id') ?? 'add';
    if (value !== '') {
      if (path !== 'add') {
        if (this.isMobile) {
          this.title = this.document.id?.toString() ?? 'New';
        } else {
          this.title = `${value} — ${this.document.id}`
        }
      } else {
        if (this.isMobile) {
          this.title = 'New';
        } else {
          this.title = 'New — ' + value;
        }
      }
    }
  }

  private prepareDocumentForSave(): Document {
    const documentToSave = new Document({ ...this.document });
    documentToSave.hotels = [];
    documentToSave.departures = [];
    documentToSave.transits = [];
    documentToSave.arrivals = [];
    documentToSave.transfers = [];
    this.sectionArrays.forEach(section => {
      const sectionCopy = { ...section };
      delete (sectionCopy as any).type;
      delete (sectionCopy as any)._deleting;
      switch (section.type) {
        case 'Hotel':
          documentToSave.hotels.push(sectionCopy);
          break;
        case 'Departure':
          documentToSave.departures.push(sectionCopy);
          break;
        case 'Transit':
          documentToSave.transits.push(sectionCopy);
          break;
        case 'Arrival':
          documentToSave.arrivals.push(sectionCopy);
          break;
        case 'Transfer':
          documentToSave.transfers.push(sectionCopy);
          break;
      }
    });
    documentToSave.type = this.myForm.get('type')?.value;
    documentToSave.documentDate = this.myForm.get('documentDate')?.value;
    return documentToSave;
  }

  formatDateForInput(dateString: string | undefined | null): string {
    if (!dateString) return '';
    const match = dateString.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})/);
    if (match) {
      return match[1] + 'T' + match[2];
    }
    return dateString.slice(0, 16);
  }

  formatDateForBackend(localDateString: string | undefined | null): string {
    if (!localDateString) return '';
    const match = localDateString.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})$/);
    if (!match) return '';
    return `${match[1]}:00+03:00`;
  }

  deleteSection(index: number) {
    if (this.loading || !this.editing) {
      return;
    }
    const sectionToDelete = this.sectionArrays[index];
    if (!sectionToDelete) return;
    sectionToDelete._deleting = true;
    setTimeout(() => {
      this.sectionArrays = this.sectionArrays.filter((_, i) => i !== index);
      this.updateOrderNumbers();
      setTimeout(() => {
        this.initializeTextareasHeight();
      }, 50);
    }, 300);
  }

  confirmDelete(id: number | undefined) {
    if (id === undefined) {
      return;
    }
    this.documentToDelete = id;
    this.showDeleteModal = true;
  }

  cancelDelete() {
    this.showDeleteModal = false;
    this.documentToDelete = undefined;
  }

  executeDelete() {
    if (this.documentToDelete === undefined) {
      return;
    }
    this.documentService.deleteDocument(this.documentToDelete).subscribe({
      next: () => {
        this.notificationService.implementNotification(new Notification({
          title: 'Success',
          text: `Document has been deleted`,
          style: NotificationType.success
        }), 5000);
        scrollUp();
        this.router.navigate(['/documents']).then(r => r);
      },
      error: (error) => {
        this.notificationService.implementNotification(new Notification({
          title: 'Error',
          text: `Failed to delete document`,
          style: NotificationType.error
        }), 5000);
      }
    });
    this.showDeleteModal = false;
    this.documentToDelete = undefined;
  }

  autoResizeTextarea(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    this.adjustTextareaHeight(textarea);
  }

  private adjustTextareaHeight(textarea: HTMLTextAreaElement): void {
    textarea.classList.add('resizing');
    textarea.style.height = 'auto';
    const newHeight = Math.max(textarea.scrollHeight, 40);
    textarea.style.height = newHeight + 'px';
    setTimeout(() => {
      textarea.classList.remove('resizing');
    }, 300);
  }

  onTextareaKeydown(event: KeyboardEvent): void {
    const textarea = event.target as HTMLTextAreaElement;
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      const cursorPosition = textarea.selectionStart;
      const currentValue = textarea.value;
      const newValue = currentValue.substring(0, cursorPosition) + '\n' + currentValue.substring(cursorPosition);
      textarea.value = newValue;
      setTimeout(() => {
        textarea.selectionStart = cursorPosition + 1;
        textarea.selectionEnd = cursorPosition + 1;
        this.adjustTextareaHeight(textarea);
      }, 10);
    } else {
      setTimeout(() => {
        this.adjustTextareaHeight(textarea);
      }, 10);
    }
  }

  initializeTextareasHeight(): void {
    setTimeout(() => {
      const textareas = document.querySelectorAll('.auto-resize-textarea');
      textareas.forEach((textarea: Element) => {
        const htmlTextarea = textarea as HTMLTextAreaElement;
        if (htmlTextarea.offsetParent === null) {
          return;
        }
        const originalTransition = htmlTextarea.style.transition;
        htmlTextarea.style.transition = 'none';
        htmlTextarea.style.height = 'auto';
        const newHeight = Math.max(htmlTextarea.scrollHeight, 40);
        htmlTextarea.style.height = newHeight + 'px';
        setTimeout(() => {
          htmlTextarea.style.transition = originalTransition;
        }, 10);
      });
    }, 100);
  }

  showEditModeRequiredModal(): void {
    if (!this.editing) {
      this.showEditModeModal = true;
    }
  }

  closeEditModeModal(): void {
    this.showEditModeModal = false;
  }

  trackByFn(index: number, item: DocumentSection): string {
    if (item.id) {
      return `${item.id}_${item.type}_${item.orderNumber}`;
    }
    const hash = btoa(JSON.stringify({
      type: item.type,
      orderNumber: item.orderNumber,
      guestNames: item.guestNames,
      hotelName: item.hotelName,
      index: index
    })).substring(0, 20);
    return `${item.type}_${item.orderNumber}_${hash}`;
  }

  getSectionsByType(type: string): DocumentSection[] {
    return this.sectionArrays.filter(section => section.type === type);
  }

  getSectionCount(type: string): number {
    return this.getSectionsByType(type).length;
  }

  hasSections(type: string): boolean {
    return this.getSectionCount(type) > 0;
  }


  addSection(type: 'Hotel' | 'Departure' | 'Transit' | 'Arrival' | 'Transfer'): void {
    if (!this.editing || this.loading) return;
    const maxOrderNumber = this.sectionArrays.length > 0
      ? Math.max(...this.sectionArrays.map(s => s.orderNumber ?? 0))
      : -1;
    const newOrderNumber = maxOrderNumber + 1;
    const baseSection = {
      id: undefined,
      orderNumber: newOrderNumber,
      active: true,
      version: 0,
      _deleting: false
    };
    let newSection: DocumentSection;
    switch (type) {
      case 'Hotel':
        newSection = {
          ...baseSection,
          type: 'Hotel',
          guestNames: '',
          hotelName: '',
          accommodation: '',
          mealPlan: '',
          stayPeriodBegin: '',
          stayPeriodEnd: '',
          checkInTime: '',
          checkOutTime: '',
          hotelAddress: '',
          hotelConfirmationNumber: '',
          additionalServices: '',
          remarks: '',
          link: '',
          cancellationPolicy: '',
          price: undefined,
          currency: ''
        } as DocumentSection;
        break;
      case 'Departure':
        newSection = {
          ...baseSection,
          type: 'Departure',
          flightDateTime: '',
          flightNumber: '',
          airportName: '',
          guests: '',
          serviceName: '',
          additionalServices: '',
          remarks: '',
          price: undefined,
          currency: ''
        } as DocumentSection;
        break;
      case 'Transit':
        newSection = {
          ...baseSection,
          type: 'Transit',
          flightDateTime: '',
          flightNumber: '',
          airportName: '',
          guests: '',
          serviceName: '',
          additionalServices: '',
          remarks: '',
          price: undefined,
          currency: ''
        } as DocumentSection;
        break;
      case 'Arrival':
        newSection = {
          ...baseSection,
          type: 'Arrival',
          flightDateTime: '',
          flightNumber: '',
          airportName: '',
          guests: '',
          serviceName: '',
          additionalServices: '',
          remarks: '',
          price: undefined,
          currency: ''
        } as DocumentSection;
        break;
      case 'Transfer':
        newSection = {
          ...baseSection,
          type: 'Transfer',
          pickUp: '',
          carAndRoute: '',
          additionalServices: '',
          remarks: '',
          price: undefined,
          currency: ''
        } as DocumentSection;
        break;
      default:
        return;
    }
    this.sectionArrays.push(newSection);
    this.openArrays = true;
    this.scrollToBottom();
    setTimeout(() => {
      this.initializeTextareasHeight();
    }, 100);
  }

  private scrollToBottom(): void {
    if (this.scrollContainer) {
      setTimeout(() => {
        const container = this.scrollContainer.nativeElement;
        container.scrollTop = container.scrollHeight;
      }, 0);
    }
  }

  private resetComponentState(): void {
    this.document = new Document({
      type: 'VOUCHER',
      hotels: [],
      departures: [],
      transits: [],
      arrivals: [],
      transfers: [],
      active: true,
      version: 0
    });
    this.primalDocument = new Document(this.document);
    this.primalId = undefined;
    this.primalType = 'VOUCHER';
    this.primalDate = undefined;
    this.title = '';
    this.documentType = '';
    this.currencyType = [];
    this.editing = false;
    this.loading = false;
    this.showDeleteModal = false;
    this.showEditModeModal = false;
    this.documentToDelete = undefined;
    this.myForm.reset();
    this.createForm();
  }

  protected readonly Icons = Icons;
}
